import { render, staticRenderFns } from "./alarm-status.vue?vue&type=template&id=6890214a&scoped=true&"
import script from "./alarm-status.vue?vue&type=script&lang=js&"
export * from "./alarm-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890214a",
  null
  
)

export default component.exports